import { createAction } from "@reduxjs/toolkit";
import { SkuState } from "state/sku/reducer";

export const setAllSku = createAction<SkuState["allSku"]>("sku/setAllSku");
